<template>
  <v-dialog v-model="open" :width="480" persistent scrollable>
    <v-card>
      <v-card-title class="headline">
        {{ value ? $t('edit_link') : $t('add_link') }}
      </v-card-title>
      <v-card-text>
        <v-form id="liffIdForm" @submit.prevent="handleSubmit">
          <div class="mt-2">
            <label :for="createId('liffId')" class="caption"
              >LIFF ID <span class="error--text">*</span></label
            >
            <v-text-field
              :id="createId('liffId')"
              v-model="form.liffId"
              v-validate="'required'"
              name="liffId"
              :data-vv-as="'LIFF ID'"
              :error-messages="errors.collect('liffId')"
              :disabled="loading"
              outline
              single-line
            />
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn :disabled="loading" @click="handleClose">{{ $t('cancel') }}</v-btn>
        <v-btn type="submit" form="liffIdForm" color="primary" :loading="loading">{{
          $t('Save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      open: false,
      form: {
        liffId: '',
        ...this.value
      },
      loading: false
    }
  },
  mounted() {
    this.open = true
  },
  methods: {
    createId(value) {
      return `${value}-${this._uid}`
    },
    handleClose() {
      this.open = false
      setTimeout(() => {
        this.$emit('close')
      }, 300)
    },
    async handleSubmit() {
      const valid = await this.$validator.validate()
      if (!valid) return

      this.loading = true
      this.$emit('submit', this.form, (ok = true) => {
        if (!ok) {
          this.loading = false
          return
        }
        this.handleClose()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/my-allianz/LinkManagement/LiffIdFormDialog.vue